import React, { memo, useEffect, useState } from 'react';
import Button from '../../../../global/atoms/button';
import GlobalModal from '../../../../global/atoms/globalModal/GlobalModal';
import { getAEMPersonalInfoData } from '../../utils/cashflowUtils';
import { useAnalyticsContext } from '../../../../../config/GoogleTagManagerEvents';
import { EVENT_ECOMMERCE_NAMES_CONFIG } from '../../../../../constants/analyticsConstants/Ecommerce';
import InfoIcon16 from '../../../../../resources/images/info16.svg';
import InfoIcon24 from '../../../../../resources/images/info_24.svg';
import { AccountInfoTestId } from '../../../GRTestId';
import './MobileModal.scss';

const MobileModal = () => {
    const [isMobileModal, setIsMobileModal] = useState(false);
    const { personalScreenConfig = {} } = getAEMPersonalInfoData() || {};
    const { mobileTooltipTitle = '', mobileTooltipDescription = '' } = personalScreenConfig || {};
    const { sendEventsForGRModalOpened, sendEventsForModalClosed } = useAnalyticsContext();

    const handleModal = () => {
        setIsMobileModal(!isMobileModal);
    };

    useEffect(() => {
        if (isMobileModal) {
            sendEventsForGRModalOpened(
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_FORM_VIEWED,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_MODAL_MOBILE,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_INFORMATION,
                ''
            );
        } else {
            sendEventsForModalClosed(
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CTA_CLICKED,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_CLOSE,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_BUTTON,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_MODAL,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CLOSE
            );
        }
    }, [isMobileModal]);

    const getTitle = () => {
        return (
            <>
                <InfoIcon24 tabIndex={'-1'} aria-hidden={true} />
                <span>{mobileTooltipTitle}</span>
            </>
        );
    };

    const getContent = () => {
        return (
            <>
                <div
                    tabIndex={'0'}
                    className="mobile-tooltip__contents"
                    dangerouslySetInnerHTML={{ __html: mobileTooltipDescription }}></div>
            </>
        );
    };

    return (
        <>
            <Button
                type="button"
                className="mobile-tooltip__btn"
                onClick={handleModal}
                buttonAriaLabel="Mobile Info"
                dataTestid={AccountInfoTestId.LICENSE_MODAL.BUTTON}>
                <InfoIcon16 aria-hidden="true" tabIndex={'-1'} />
            </Button>

            <GlobalModal
                titleClasses={'mobile-tooltip_title'}
                className={'width-327'}
                isOpen={isMobileModal}
                onRequestClose={handleModal}
                title={getTitle()}
                content={getContent()}
                handleClose={handleModal}
            />
        </>
    );
};

export default memo(MobileModal);
